/**
 * Pill geometry, keyed by height token. Internal to ui: Button, Badge, Chip,
 * IconPill and SelectionPill each map their own size names to a row, and
 * set `height` to the key.
 *
 * The icon side is about half the text side, because an icon carries its own
 * whitespace.
 */
export const pillSizes = {
  "$si2.5": {
    sidePadding: "$sp0.75",
    iconSidePadding: "$sp0.5",
    gap: "$sp0.5",
    iconSize: "$iconXSmall",
  },
  $si3: {
    sidePadding: "$sp1.5",
    iconSidePadding: "$sp0.75",
    gap: "$sp0.5",
    iconSize: "$iconSmall",
  },
  $si4: {
    sidePadding: "$sp1.5",
    iconSidePadding: "$sp0.75",
    gap: "$sp1",
    iconSize: "$iconSmall",
  },
  $si5: {
    sidePadding: "$sp2",
    iconSidePadding: "$sp1",
    gap: "$sp1",
    iconSize: "$iconMedium",
  },
  $si7: {
    sidePadding: "$sp4",
    iconSidePadding: "$sp3",
    gap: "$sp1",
    iconSize: "$iconLarge",
  },
} as const;

export type PillSize = keyof typeof pillSizes;

/** Side padding for a pill, tightened on the side that holds an icon or avatar. */
export const pillSlotPadding = (
  size: PillSize,
  {
    leading = false,
    trailing = false,
  }: { leading?: boolean; trailing?: boolean } = {},
) => {
  const { sidePadding, iconSidePadding } = pillSizes[size];
  return {
    paddingLeft: leading ? iconSidePadding : sidePadding,
    paddingRight: trailing ? iconSidePadding : sidePadding,
  };
};
